// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-vT9h","content":"styles_content__30YkC","selectAll":"styles_selectAll__3b0Un"};